import React, { useState, useRef } from "react";
import { Dialog, IconButton, Paper, Typography, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { privilegeDefinitions } from "../../utils/PrivilegeDefinitions";

const PrivilegesDefinition = ({ open, onClose }) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const dragStartPos = useRef({ x: 0, y: 0 });

  const handleMouseDown = (e) => {
    if (e.target.closest("button") === null) {
      setIsDragging(true);
      dragStartPos.current = {
        x: e.clientX - position.x,
        y: e.clientY - position.y,
      };
    }
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    setPosition({
      x: e.clientX - dragStartPos.current.x,
      y: e.clientY - dragStartPos.current.y,
    });
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleClose = (e) => {
    e.stopPropagation();
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={() => {}}
      hideBackdrop
      disableEscapeKeyDown
      PaperComponent={({ children }) => (
        <Paper
          style={{
            margin: 0,
            position: "fixed",
            transform: `translate(${position.x}px, ${position.y}px)`,
            cursor: isDragging ? "grabbing" : "default",
            maxHeight: "90vh",
            overflow: "hidden",
            width: "421px",
            borderRadius: "8px",
            pointerEvents: "auto",
            display: "flex",
            flexDirection: "column",
          }}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseUp}
        >
          {children}
        </Paper>
      )}
      sx={{
        pointerEvents: "none",
        "& .MuiDialog-container": {
          pointerEvents: "none",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: isDragging ? "grabbing" : "grab",
          padding: "25px",
          borderBottom: "2px solid #FF890A",
          backgroundColor: "#FFFFFF",
          position: "sticky",
          top: 0,
          zIndex: 1,
          flexShrink: 0,
        }}
        onMouseDown={handleMouseDown}
      >
        <Typography
          sx={{
            fontSize: "21px",
            fontWeight: 700,
            lineHeight: "26px",
            color: "#1E1E1E",
          }}
        >
          Privileges Definition
        </Typography>
        <IconButton
          onClick={handleClose}
          sx={{
            "&:hover": { backgroundColor: "rgba(0,0,0,0.04)" },
            marginLeft: "auto",
            padding: "0px",
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <Box
        sx={{
          p: "25px",
          display: "flex",
          flexDirection: "column",
          rowGap: "25px",
          overflowY: "auto",
          flexGrow: 1,
        }}
      >
        {privilegeDefinitions.map((privilege, index) => (
          <Box
            key={index}
            sx={{
              borderBottom:
                index < privilegeDefinitions.length - 1
                  ? "1px solid #A29D9B"
                  : "none",
              paddingBottom: "25px",
              "&:last-child": {
                paddingBottom: 0,
              },
            }}
          >
            <Typography
              sx={{
                fontSize: "14px",
                lineHeight: "20px",
                fontWeight: 700,
                letterSpacing: "0.15px",
                color: "black",
                mb: "2px",
              }}
            >
              {privilege.title}
            </Typography>
            <Typography
              sx={{
                fontSize: "16px",
                lineHeight: "22px",
                fontWeight: 500,
                color: "black",
                fontFamily: "QuicksandRegular",
              }}
            >
              {privilege.description}
            </Typography>
          </Box>
        ))}
      </Box>
    </Dialog>
  );
};

export default PrivilegesDefinition;
